import { useEffect, useState } from 'react';
import { getCertificateTemplate } from '../../api/getCertificateTemplateApiService';
import type { CertificateTemplateDetail } from '../../types';

export function useViewCertificateTemplate(id: string) {
  const [loading, setLoading] = useState(true);
  const [template, setTemplate] = useState<CertificateTemplateDetail | null>(
    null
  );
  const [notFound, setNotFound] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setNotFound(false);
    setError('');

    getCertificateTemplate(id).then((result) => {
      if (!mounted) {
        return;
      }
      if (result.success && result.data) {
        setTemplate(result.data);
      } else if (result.notFound) {
        setNotFound(true);
      } else {
        setError(result.error ?? '');
      }
      setLoading(false);
    });

    return () => {
      mounted = false;
    };
  }, [id]);

  return { loading, template, notFound, error };
}
